import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ImprovementsConfig } from './improvements-config';
import { Signature } from './signature.model';

// TODO: Move this to shared variable / shared model.
const SKIP_401_STATUS_CHECK = 'SKIP-401-STATUS-CHECK';

@Injectable({
  providedIn: 'root',
})
export class SignatureService {
  refreshTokenInProgress = false;
  refreshTokenSubject$ = new BehaviorSubject<Signature | null>(null);

  constructor(private http: HttpClient, private config: ImprovementsConfig) {}

  getSignature(): Observable<Signature> {
    return this.http.get<Signature>(
      this.config.managerUrl + '/api/authentications/sign',
      {
        // Setting Accept-Version Since it is required for OPS App process.
        // In contractor portal we have auth.interceptor which is why it is working.
        headers: {
          'Content-Type': 'application/json',
          'Accept-Version': 'v1',
          [SKIP_401_STATUS_CHECK]: 'true',
        },
      }
    );
  }
}
